export const RectIconV2 = () => {
  return (
    <svg fill="none" height="21" viewBox="0 0 20 21" width="20" xmlns="http://www.w3.org/2000/svg">
      <rect
        height="18.32"
        stroke="white"
        strokeLinejoin="round"
        strokeWidth="1.68"
        width="18.32"
        x="0.84"
        y="1.76349"
      />
    </svg>
  );
};
